import { useEffect, useState } from "react";
import { getWeeklyLeaderboard } from "../../services/scoreService";
import styles from "./Leaderboard.module.css";
import NavBar from "../../components/nav-bar/nav-bar";

function formatDate(date) {
    return date.toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
    });
}

export default function Leaderboard() {
    const [scores, setScores] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getWeeklyLeaderboard()
            .then(setScores)
            .finally(() => setLoading(false));
    }, []);

    // const now = new Date();
    // const day = now.getDay();
    // const diff = day === 0 ? -6 : 1 - day;

    // const monday = new Date(now);
    // monday.setDate(now.getDate() + diff);
    // monday.setHours(0, 0, 0, 0);

    // const nextMonday = new Date(monday);
    // nextMonday.setDate(monday.getDate() + 7);

    // const sorted = scores.sort((a, b) => {
    //     if (b.score !== a.score) {
    //         return b.score - a.score; // higher score first
    //     }
    //     if (a.timeSeconds !== b.timeSeconds) {
    //         return a.timeSeconds - b.timeSeconds; // faster wins
    //     }
    //     return 0;
    // });

    scores.unshift({
        id: 'QodoAI',
        firstName: 'QodoAI Reviewer',
        score: 100000,
        timeSeconds: 0.8
    })

    return (
        <>
            <NavBar></NavBar>
            <div className={styles.container}>

                <div className={styles.starsWrap}>
                    <div id='stars'></div>
                    <div id='stars2'></div>
                    <div id='stars3'></div>
                </div>
                <h1 className={styles.title}>🏆 Weekly Leaderboard</h1>

                {/* <p className={styles.range}>
                    {formatDate(monday)} – {formatDate(nextMonday)}
                </p> */}
                <div className={styles.tableWrap}>


                    {loading && <p className={styles.loading}>Loading scores…</p>}

                    {!loading && scores.length === 0 && (
                        <p className={styles.empty}>No scores yet this week 👀</p>
                    )}

                    {!loading && scores.length > 0 && (
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th className={styles.rank}>#</th>
                                    <th>Name</th>
                                    <th>Score</th>
                                    <th>Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {scores.map((s, i) => (
                                    <tr key={s.id}>
                                        <td className={styles.rank}>{i + 1}</td>
                                        <td className={styles.name}>{s.firstName}</td>
                                        <td className={styles.score}>{s.score}</td>
                                        <td>{s.timeSeconds}s</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </>
    );
}
